module.exports = __webpack_public_path__ + "img/cqfw5.934e41c2.png";